/*=========================================================================================
  File Name: moduleMap.js
  Description: Todo Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import state from "./moduleGroupState.js";
import mutations from "./moduleGroupMutations.js";
import actions from "./moduleGroupActions.js";
import getters from "./moduleGroupGetters.js";

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
